module.exports = __webpack_public_path__ + "img/check-mark.40042902.svg";